import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';

var Weekdays = /*#__PURE__*/function () {
  var Weekdays = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Weekdays, _Component);

    function Weekdays() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = Weekdays.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    };

    _proto.render = function render() {
      var _this$props = this.props,
          classNames = _this$props.classNames,
          firstDayOfWeek = _this$props.firstDayOfWeek,
          showWeekNumbers = _this$props.showWeekNumbers,
          weekdaysLong = _this$props.weekdaysLong,
          weekdaysShort = _this$props.weekdaysShort,
          locale = _this$props.locale,
          localeUtils = _this$props.localeUtils,
          weekdayElement = _this$props.weekdayElement;
      var days = [];

      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = /*#__PURE__*/React.isValidElement(weekdayElement) ? /*#__PURE__*/React.cloneElement(weekdayElement, elementProps) : /*#__PURE__*/React.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: classNames.weekdays,
        role: "rowgroup"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames.weekdaysRow,
        role: "row"
      }, showWeekNumbers && /*#__PURE__*/React.createElement("div", {
        className: classNames.weekday
      }), days));
    };

    return Weekdays;
  }(Component);

  return Weekdays;
}();

export default Weekdays;